<template>
  <v-app id="app">
    <div >
      <v-app-bar
        app
        clipped-left
        flat
        height="68"
        color="white"
        class="modern-app-bar border-bottom"
        v-if="showAppBar"
      >
        <v-app-bar-nav-icon @click="drawer = !drawer" class="d-md-none primary--text"></v-app-bar-nav-icon>
        
        <div class="d-flex align-center cursor-pointer" @click="$router.push('/')">
          <div class="d-flex align-center mr-4">
            <v-img
              max-height="38"
              max-width="48"
              src="./assets/runflow_logo.png"
              contain
              class="mr-2"
            ></v-img>
            <span class="text-h6 mb-1">{{ flag }}</span>
          </div>
          
          <div class="d-none d-md-flex align-center">
            <div class="separator-v mr-4"></div>
            <div class="d-flex align-center">
              <v-avatar v-if="companyLogo" size="32" tile class="mr-3 rounded border-light bg-white">
                <v-img :src="companyLogo" contain></v-img>
              </v-avatar>
              <span class="text-subtitle-1 font-weight-black primary--text tracking-tight">{{ fantasy }}</span>
            </div>
          </div>
        </div>

        <v-spacer></v-spacer>
       
        <div v-if="user" class="d-flex align-center">
          <div class="text-right mr-4 d-none d-sm-block">
            <div class="body-2 font-weight-black primary--text lh-1 mb-1">{{user.first_name}} {{user.last_name}}</div>
            <div class="caption grey--text text--darken-1 font-weight-bold uppercase tracking-widest-xs">{{user.user_role.name}}</div>
          </div>
          <v-avatar color="primary" size="40" class="shadow-sm border-white-sm profile-avatar">
            <span class="white--text font-weight-black body-2">{{ userInitials }}</span>
          </v-avatar>
        </div>
      </v-app-bar>
      <side-menu
        v-if="showAppBar"
        :drawer="drawer"
        :user="user"
        @logout="logOut"
        @update:drawer="drawer = $event"
      />
        
       
      </div>
    <notifications
      group="principal"
      width="30%"
      position="top right"
      animation-type="velocity"
      reverse="true"
      :speed="350"
      style="z-index: 99999 !important;"
    />
    <v-main>
      <v-container
        fluid
      >
      <router-view :key="$route.fullPath" />
    </v-container>
  </v-main>
  </v-app>
</template>

<script>
import {logout} from '@/api/auth'
import SideMenu from '@/components/menu/SideMenu'
import TopMenu from '@/components/menu/TopMenu'
import menu from '@/utils/menu'
import getInternacional from './utils/internacional'

  export default {
    components:{SideMenu,TopMenu},
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      snackbar: true,
      menus:menu,
      noAppBarRoutes:['Login','PasswordResetEmail','PasswordResetRequest','Congratulations'],
    }),
    methods:{
      logOut(){
        logout()
        this.$router.push('/auth/login')
      },
      toggleDark(){
        this.$vuetify.theme.dark=!this.$vuetify.theme.dark
      },
      goTo(link){
        this.$router.push('/'+link)
      },
    },
    watch:{
      '$vuetify.breakpoint.mdAndUp'(isDesktop){
        if(isDesktop) this.drawer = null
      }
    },
    computed:{
      user(){
        return this.$store.getters.getUser
      },
      fantasy(){
        return this.$store.getters.getCompany.fantasy
      },
      flag(){
        const code = this.$store.getters.getCompany.country_code || 'cl'
        return getInternacional(code)?.emogi_flag || ''
      },
      showAppBar(){
        return !this.noAppBarRoutes.includes(this.$route.name)
      },
      companyLogo(){
        return this.$store.getters.getCompany.logo_url
      },
      userInitials() {
        if(!this.user) return '??'
        const first = this.user.first_name?.[0] || ''
        const last = this.user.last_name?.[0] || ''
        return (first + last).toUpperCase()
      },
      filteredMenus(){
        if (!this.menus) return []
        return this.menus.map(menu => {
          const filtered = { ...menu }
          filtered.items = menu.items.filter(item => this.$can('read', item.gate))

          const softnetDisabled = !this.$store.getters.getCompany.softnet_integration_enabled
          if (softnetDisabled) {
            filtered.items = filtered.items.filter(item => item.link !== 'sales/softnet-documents')
          }
          const kameDisabled = !this.$store.getters.getCompany.kame_integration_enabled
          if (kameDisabled) {
            filtered.items = filtered.items.filter(item => item.link !== 'sales/kame-documents')
          }
          
          const relbaseDisabled = !this.$store.getters.getCompany.relbase_integration_enabled
          if (relbaseDisabled) {
            filtered.items = filtered.items.filter(item => 
              item.link !== 'ventas/relbase-documents' &&
              item.link !== 'reports/relbase-sync' &&
              item.link !== 'reports/relbase-product-billing'
            )
            if (menu.title === 'Relbase') {
              filtered.items = []
            }
          }

          return filtered
        }).filter(menu => menu.items.length > 0)
      }
    },
  }
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;600;700&family=Lato:wght@400;700&display=swap');

#app {
  font-family: 'Lato', sans-serif;
  background-color: #F8FAFC;
}
.titulo{
  font-family: 'Raleway', sans-serif;
  font-weight: 700 !important;
  font-size: 24px !important;
  color: #1A1F2E !important;
}

.titulo-2{
  font-family: 'Raleway', sans-serif;
  font-weight: 600 !important;
  font-size: 20px !important;
  color: #1A1F2E !important;
}

.table-header {
    font-weight:normal;
    font-size:medium !important;
    color: var(--v-primary-base) !important;
}
.table-header-dense {
    font-weight:normal;
    font-size:small !important;
    color: var(--v-primary-base) !important;
}
.table-body {
  font-weight:normal;
  font-size:large !important;
  color: #2D3436 !important;
}

#keep .v-navigation-drawer__border {
  display: none
}
//Estilos para las notificaciones
// .vue-notification {
//   border-radius: 5px;
//   // Style of the notification itself 
  
//   .notification-title {
//     font-weight: 10 ;
//   }
 
//   .notification-content {
//     // Style for content
//     font-size: large; 
//   }
  
//  }
.vue-notification {
  padding: 10px;
  margin: 10px 10px 5px;
  font-size: 14px;
  color: #ffffff;
  background: #1A1F2E;
  border-left: 5px solid #35BDC8;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 99999 !important;
  position: relative;

  .notification-title {
    font-weight: 700;
    margin-bottom: 4px;
    font-family: 'Raleway', sans-serif;
  }

  &.warn {
    background: #FFC107;
    border-left-color: #FFA000;
    color: #1A1F2E; // Contraste oscuro para amarillo
  }

  &.error {
    background: #F44336;
    border-left-color: #D32F2F;
  }

  &.success {
    background: #4CAF50;
    border-left-color: #388E3C;
  }
}

// Story 1.6: Global Feedback Aesthetics (Loading, Dialogs, Transitions)
.v-progress-linear__indeterminate,
.v-progress-circular {
  color: var(--v-accent-base) !important;
}

// Asegurar que v-card dentro de v-dialog herede el border-radius de 8px
.v-dialog > .v-card {
  border-radius: 8px !important;
  overflow: hidden;
}

// Micro-interactions: Transiciones suaves globales
.v-btn, .v-card, .v-list-item {
  transition: all 0.3s ease !important;
}

// v-snackbar: Modernizar estética (AC: 4)
.v-snack__wrapper {
  border-radius: 8px !important;
  background-color: #1A1F2E !important; // Slate Navy por defecto
  
  &.v-sheet--outlined {
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
}

.v-snack__content {
  font-family: 'Lato', sans-serif;
  font-weight: 600;
}

// Mejorar la transición de escala por defecto de Vuetify para que se sienta más "premium"
.scale-transition-enter-active,
.scale-transition-leave-active {
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), opacity 0.3s ease !important;
}


// Form spacing consistency (Story 1.4)
.v-form .v-input,
.v-card .v-input {
  margin-bottom: 4px;
}

// Accent button contrast (Story 1.4)
.v-btn.accent {
  color: #ffffff !important;
}

// Story 1.5: Zebra-striping sutil para v-data-table (AC: 3, 7)
.v-data-table tbody tr:nth-child(odd) {
  background-color: #F8FAFC;
}

// Preservar hover state de Vuetify sobre zebra-striping
.v-data-table tbody tr:hover {
  background-color: #EDF2F7 !important;
}

// Story 1.5: Tipografía tabular para columnas numéricas (AC: 4, 7)
// Uso: agregar cellClass: 'numeric-column' y align: 'end' en headers de v-data-table
.numeric-column {
  font-variant-numeric: tabular-nums;
  text-align: right;
}

// Modern Table System
.modern-table {
  border-radius: 8px !important;
  
  .v-data-table-header {
    th {
      font-family: 'Raleway', sans-serif;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      font-weight: 700;
      font-size: 0.75rem !important;
      color: #64748B !important;
      background-color: #F1F5F9 !important;
      border-bottom: 2px solid #E2E8F0 !important;
    }
  }

  tbody {
    tr:hover {
      background-color: #F1F5F9 !important;
    }
    
    // Fix expansion background issues
    &.v-data-table__expanded__content {
      background-color: #FFFFFF !important;
      box-shadow: inset 0 4px 6px -1px rgba(0, 0, 0, 0.05);
      
      .v-card, .v-simple-table {
        background-color: transparent !important;
      }
    }
  }
}

.modern-summary-table {
  thead th {
    background-color: #F8FAFC !important;
    color: #1A1F2E !important;
    border-bottom: 1px solid #E2E8F0 !important;
  }
  
  tbody td {
    padding: 16px !important;
    border-bottom: none !important;
  }
}

.numeric-input {
  input {
    text-align: right !important;
    font-variant-numeric: tabular-nums;
  }
}

// App Bar & Main Template Refinements
.modern-app-bar {
  border-bottom: 1px solid rgba(0,0,0,0.06) !important;
  font-family: 'Outfit', sans-serif !important;
}

.separator-v {
  width: 1px;
  height: 24px;
  background-color: rgba(0,0,0,0.08);
}

.flag-chip {
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 700;
}

.bg-grey-light {
  background-color: #f1f5f9 !important;
}

.tracking-tight {
  letter-spacing: -0.5px;
}

.tracking-widest-xs {
  letter-spacing: 1.2px;
}

.profile-avatar {
  border: 2px solid #FFFFFF !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
}

.lh-1 {
  line-height: 1 !important;
}

.cursor-pointer {
  cursor: pointer;
}

// Overwrite Vuetify defaults for a cleaner look
.v-text-field--outlined.v-input--dense .v-label {
  top: 7px;
}
</style>